import { PieChart } from '@mui/x-charts/PieChart';
import { Card, CardContent, Typography } from '@mui/material';
import Loading from '../../components/loading';
import { useFinancialDashboardResource } from './hooks/useFinancialDashboardResource';

export function ExpensesByCategoryPieChart({ selectedDate, viewByYear, viewAllPeriod }) {
  const { data: expensesByCategory, isLoading } = useFinancialDashboardResource(
    '/financial/dashboard/expenses-by-categories',
    { selectedDate, viewByYear, viewAllPeriod },
    [],
  );

  const data = expensesByCategory.map((item) => ({
    id: item.categoryId,
    value: item.totalAmount,
    percentage: item.percentage,
    label: `${item.categoryName} - ${item.totalAmountFormatted}`,
  }));

  return (
    <Card sx={{ position: 'relative' }}>
      <Loading isToHidden={isLoading === false} />
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Saídas por Categoria
        </Typography>

        <PieChart
          series={[
            {
              data,
              innerRadius: 50,
              outerRadius: 110,
              paddingAngle: 2,
              arcLabel: (item) => `${item.percentage}%`,
              arcLabelMinAngle: 15,
            },
          ]}
          height={280}
        />
      </CardContent>
    </Card>
  );
}
